import styled from 'styled-components';

export const StoriesContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const StoryImage = styled.img`
  height: 800px;
  width: 500px;
  object-fit: cover;
  border-radius: 40px;
`;

export const ProgressContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 4px;
`;

export const StoryHeaderContainer = styled.div`
  position: absolute;
  top: 23px;
  z-index: 2;
  display: flex;
  width: 100%;
  flex-direction: column;
  padding-left: 32px;
  padding-right: 32px;
  align-items: center;
  justify-content: center;
  gap: 8px;
`;

export const StoryFooterContainer = styled.div`
  position: absolute;
  display: flex;
  flex-direction: row;
  bottom: 23px;
  z-index: 2;
  gap: 16px;
  width: 452px;
  height: 40px;
  align-items: center;
  justify-content: center;
`;

export const ReplyForm = styled.form`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
`;

export const ReplyInput = styled.input`
  width: 360px;
  height: 40px;
  border: none;
  padding: 0 16px;
  background-color: transparent;
  border-top: 1px solid #FCFCFC;
  border-bottom: 1px solid #FCFCFC;
  color: #FCFCFC;
`;

export const UserName = styled.p`
  font-size: 12px;
  color: #FCFCFC;
`;

export const UserContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
  align-items: center;
`;

export const Controls = styled.div`
  display: flex;
`;

export const Control = styled.div`
  width: 200px;
  height: 200px;
  background-color: rgba(0, 0, 0, 0.5);
  cursor: pointer;
`;

export const ControlButtonWrapper = styled.button`
  background-color: transparent;
  border: 0;
`;

export const ProgressBarContainer = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  padding: 8px;
`;